// extracted by mini-css-extract-plugin
export default {"projectnavMobil":"formheadMobil_projectnavMobil__kmFHZ"};